export const sortByStudent = (a, b) => {
  const aFullname = `${a.student.first_name} ${a.student.last_name}`.toLowerCase();
  const bFullname = `${b.student.first_name} ${b.student.last_name}`.toLowerCase();
  return aFullname > bFullname ? 1 : -1;
};
